import { render, staticRenderFns } from "./infusion.vue?vue&type=template&id=d651645e&scoped=true&"
import script from "./infusion.vue?vue&type=script&lang=js&"
export * from "./infusion.vue?vue&type=script&lang=js&"
import style0 from "./infusion.vue?vue&type=style&index=0&id=d651645e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d651645e",
  null
  
)

export default component.exports